import { BarItem } from '../types';

import { PresetItem } from 'app/lib/site-configs/transform-preset-item';

export function isPreset(item: BarItem): item is PresetItem {
  return 'type' in item && item.type ==='presets';
}
